import {FC} from 'react';

import {Box, DialogContent, Stack, Typography} from '@mui/material';
import {t} from 'i18next';
import {Trans} from 'react-i18next';

import {OfferToCarryProduct} from 'assets/icons/offerToCarryProduct';
import {TruckLeo1P} from 'assets/icons/truckLeo1P';
import dateFormats, {formatDate} from 'utils/dateFormats';

import {BasketDialogTitle} from './BasketDialogTitle';
import {BulletPoints, StyledDialog, DeliveryStyledPDPNextDay, StyledBottomSheet} from './styles';

export interface BasketDeliveryDetailsBulkyModalV2 {
  open: boolean;
  onClose: () => void;
  is1Px?: boolean;
  shippingInfo?: {
    deliveryTimeEarliestDate?: string | Date;
    deliveryTimeLatestDate?: string | Date;
  };
  isReactNativeWebView: boolean;
  pure1PxProducts?: boolean;
}

export const BasketDeliveryDetailsBulkyModalV2: FC<BasketDeliveryDetailsBulkyModalV2> = ({
  open,
  onClose,
  is1Px,
  shippingInfo,
  isReactNativeWebView,
  pure1PxProducts
}) => {
  const formatDeliveryDate = formatDate(dateFormats.deliveryDate);
  const ModalContainer = isReactNativeWebView ? StyledBottomSheet : StyledDialog;
  return (
    <ModalContainer className="MakroFleetDeliveryModal" open={open} onClose={onClose} anchor="bottom">
      <BasketDialogTitle title={t('sellerDelivery.makroFleet.deliveryHandledByMakro')} onClose={onClose} />
      <DialogContent>
        <Stack spacing={2}>
          <Box display={'flex'} gap={0.5}>
            <DeliveryStyledPDPNextDay>
              {is1Px && shippingInfo
                ? t('message.deliveryBetween', {
                    earliestDate: formatDeliveryDate(shippingInfo?.deliveryTimeEarliestDate),
                    latestDate: formatDeliveryDate(shippingInfo?.deliveryTimeLatestDate)
                  })
                : t('sellerDelivery.makroFleet.nextDayDelivery')}
            </DeliveryStyledPDPNextDay>
            <TruckLeo1P width={32} height={18} fill="#F8505A" />
          </Box>
          <BulletPoints>
            {!is1Px && (
              <li>
                <Typography fontSize={'14px'} fontWeight={400}>
                  <Trans i18nKey={'sellerDelivery.makroFleet.getByTomorrow'} />
                </Typography>
              </li>
            )}
            <li>
              <Typography fontSize={'14px'} fontWeight={400}>
                {t('sellerDelivery.makroFleet.chooseDateAtCheckout')}
              </Typography>
            </li>
            <li>
              <Typography fontSize={'14px'} fontWeight={400}>
                {t('sellerDelivery.makroFleet.deliverToSpecificPoint')}
              </Typography>
            </li>
            {!pure1PxProducts && (
              <li>
                <Typography fontSize={'14px'} fontWeight={400}>
                  {t('sellerDelivery.makroFleet.floorFee')}
                </Typography>
              </li>
            )}
          </BulletPoints>
          <Box display="flex" gap={1} border={0.5} p={1} borderRadius={1.5} borderColor="grey.200" width="fit-content">
            <OfferToCarryProduct />
            <Typography fontSize={12} fontWeight={700}>
              {t('sellerDelivery.makroFleet.offerToCarryProduct')}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={12} fontWeight={400} color="grey.400">
              {t('sellerDelivery.makroFleet.makroFleetRemark')}
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
    </ModalContainer>
  );
};

BasketDeliveryDetailsBulkyModalV2.displayName = 'BasketDeliveryDetailsBulkyModalV2';
